// Brand assets and constants
export const OVAMX_LOGO =
  "https://customer-assets.emergentagent.com/wingman/f424b91f-0ab3-42bd-a2d7-92bcb32f7395/attachments/1044e3b0a3544c45a10b94ecb4075471_ovamax%20logo.png";
